import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header/Header';
import NavInf from '../../components/NavInf/NavInf';
import Footer from '../../components/Footer/Footer';
import './SAIHelp.css';

const SAIHelp = () => {
    return (
        <>
            <Header />

            {/* Main Content */}
            <div className="sai-ayuda-container">
                <div className="sai-ayuda-hero-section">
                    <h1 className="sai-ayuda-hero-title">Centro de Ayuda SAI</h1>
                    <p className="sai-ayuda-hero-subtitle">Todo lo que necesitas saber sobre el Sistema de Abonos Inteligentes</p>
                </div>

                <div className="sai-ayuda-content-wrapper">
                    {/* Sección 1: ¿Qué es el sistema SAI? */}
                    <section id="que-es-sai" className="sai-ayuda-help-section">
                        <h2 className="sai-ayuda-section-title">¿Qué es el sistema SAI?</h2>
                        <div className="sai-ayuda-answer-content">
                            <p className="sai-ayuda-text">
                                El Sistema de Abonos Inteligentes (SAI) es una plataforma revolucionaria que transforma completamente
                                la gestión financiera de tu negocio. Diseñado específicamente para optimizar el manejo de pagos, deudas
                                y flujo de efectivo, SAI te permite tomar decisiones financieras estratégicas con precisión matemática.
                            </p>

                            <h3 className="sai-ayuda-subsection-title">¿Qué hace especial al SAI?</h3>
                            <ul className="sai-ayuda-features-list">
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Simulación inteligente de abonos que maximiza el impacto de cada peso invertido</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Gestión estratégica de múltiples proveedores con priorización automática</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Control de flujo de caja en tiempo real para decisiones inmediatas</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Interfaz drag & drop para reorganizar pagos según tus prioridades comerciales</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Validaciones inteligentes que previenen errores financieros costosos</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Proyecciones de saldo que te muestran el impacto futuro de cada decisión</span>
                                </li>
                            </ul>

                            <p className="sai-ayuda-text">
                                SAI no es solo una herramienta de cálculo; es tu asesor financiero inteligente que te ayuda a
                                optimizar cada peso, fortalecer relaciones comerciales y mantener un flujo de caja saludable
                                para el crecimiento sostenible de tu negocio.
                            </p>
                        </div>
                    </section>

                    {/* Sección 2: ¿Qué puedo lograr usando el SAI? */}
                    <section id="que-puedo-lograr" className="sai-ayuda-help-section">
                        <h2 className="sai-ayuda-section-title">¿Qué puedo lograr usando el SAI?</h2>
                        <div className="sai-ayuda-answer-content">
                            <p className="sai-ayuda-text">
                                Con SAI, transformarás la manera en que manejas las finanzas de tu negocio, alcanzando niveles
                                de eficiencia y control que antes parecían imposibles. Los resultados son inmediatos y duraderos.
                            </p>

                            <h3 className="sai-ayuda-subsection-title">Resultados Financieros Inmediatos:</h3>
                            <ul className="sai-ayuda-features-list">
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Reducir el tiempo de decisión de pagos de horas a minutos con simulaciones precisas</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Optimizar hasta un 40% más tu capital disponible con distribución inteligente</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Eliminar errores de cálculo que pueden costar miles de pesos en sobregiros</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Mantener relaciones comerciales sólidas con pagos estratégicos y oportunos</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Proyectar escenarios financieros para planificar el crecimiento de tu negocio</span>
                                </li>
                            </ul>

                            <h3 className="sai-ayuda-subsection-title">Ventajas Estratégicas a Largo Plazo:</h3>
                            <ul className="sai-ayuda-features-list">
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Desarrollar credibilidad comercial con proveedores mediante pagos consistentes</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Acceder a mejores condiciones comerciales por tu historial de pagos organizado</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Crear un sistema financiero escalable que crece con tu negocio</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Obtener tranquilidad mental al tener control total sobre tus obligaciones</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text">Dedicar más tiempo al crecimiento del negocio en lugar de cálculos manuales</span>
                                </li>
                            </ul>

                            <p className="sai-ayuda-text">
                                El SAI te convierte en un experto en gestión financiera, sin importar tu nivel de experiencia previo.
                                Es como tener un contador y un asesor financiero trabajando 24/7 para optimizar cada decisión de pago.
                            </p>
                        </div>
                    </section>

                    {/* Sección 3: ¿Cómo uso la plataforma para el método SAI? */}
                    <section id="como-usar-plataforma" className="sai-ayuda-help-section">
                        <h2 className="sai-ayuda-section-title">¿Cómo uso la plataforma para el método SAI?</h2>
                        <div className="sai-ayuda-answer-content">
                            <p className="sai-ayuda-text">
                                Usar SAI es sorprendentemente simple y intuitivo. En menos de 5 minutos dominarás el sistema
                                que revolucionará tu gestión financiera. Cada paso está diseñado para ser lógico y eficiente.
                            </p>

                            <h3 className="sai-ayuda-subsection-title">Proceso Paso a Paso:</h3>
                            <ul className="sai-ayuda-features-list">
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Ingresa tu capital disponible:</strong> Escribe la cantidad exacta de dinero que tienes para distribuir hoy</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Visualiza tus proveedores:</strong> El sistema muestra automáticamente todas tus deudas organizadas y actualizadas</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Arrastra para priorizar:</strong> Reorganiza los proveedores según tu estrategia comercial usando drag & drop</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Simula abonos inteligentes:</strong> Toca cualquier proveedor para simular diferentes montos de pago</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Valida en tiempo real:</strong> El sistema te avisa si excedes tu presupuesto o la deuda del proveedor</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Ve proyecciones instantáneas:</strong> Observa cómo cada abono afecta el saldo total y individual</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Guarda tu estrategia perfecta:</strong> Una vez satisfecho con la distribución, guarda la simulación</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Ejecuta con confianza:</strong> Procede con los pagos sabiendo que cada peso está optimizado</span>
                                </li>
                            </ul>

                            <h3 className="sai-ayuda-subsection-title">Funciones Avanzadas:</h3>
                            <ul className="sai-ayuda-features-list">
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Reinicio rápido:</strong> Borra toda la simulación con un clic para empezar con nuevos parámetros</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Alertas inteligentes:</strong> Recibe notificaciones visuales cuando algo requiere tu atención</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Modo responsivo:</strong> Usa SAI perfectamente desde tu celular, tablet o computador</span>
                                </li>
                                <li className="sai-ayuda-feature-item">
                                    <FontAwesomeIcon icon={faCheck} className="sai-ayuda-check-icon" />
                                    <span className="sai-ayuda-feature-text"><strong>Cálculos automáticos:</strong> Todo se actualiza instantáneamente sin necesidad de botones adicionales</span>
                                </li>
                            </ul>

                            <p className="sai-ayuda-text">
                                La belleza del SAI radica en su simplicidad: tecnología avanzada que funciona de manera tan
                                intuitiva que te sentirás como un experto desde el primer uso. Es la herramienta que siempre
                                quisiste tener para manejar tus finanzas comerciales con precisión profesional.
                            </p>
                        </div>
                    </section>
                </div>
            </div>

            <NavInf />
            <Footer />
        </>
    );
};

export default SAIHelp;
